import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$works = new Vue({
  methods: {
    get(language = "en", filters = {}) {
      let lang = language;
      const limit = 30;

      if (lang === "pt") {
        lang = "pt-br";
      }

      let url = `${getBaseUrl()}jobs/${lang}?limit=${limit}`;

      if (filters?.page) {
        url += `&page=${filters.page}`;
      }

      if (filters?.regional) {
        url += `&office=${filters.regional}`;
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(url)
          .then(({ data }) => {
            if (filters.regional === undefined) {
              const { items } = data?.data || {};
              if (items) {
                items.sort(({ date: a }, { date: b }) => {
                  const [da, ma, ya] = a.split("/");
                  const [db, mb, yb] = b.split("/");
                  return new Date(`${yb}-${mb}-${db}`) - new Date(`${ya}-${ma}-${da}`);
                });
              }
            }
            resolve(data);
          })
          .catch((error) => reject(error));
      });
    },

    getSingle(language, slug) {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(`${getBaseUrl()}jobs/${lang}/${slug}`)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
